import { UserClaimDto } from "../app/model/api/types/dto";

export class UserClaimsViewModel {
    userId: string | null;
    claims: [] | null;
    constructor(
        userId: string | null,
        claims: [] | null,
    ) {
        this.userId = userId;
        this.claims = claims;
        
    }

    toDto(): UserClaimDto {
        
        return {
            userId: this.userId,
            claims: this.claims,
        };
    }

    mapFromDto(dto: UserClaimDto): void {
        this.userId = dto.userId;
        this.claims = dto.claims;
    }
}

